import type { SVGProps } from "react";

export const UserAccountSelectedIcon2 = ({
  props,
}: {
  props?: SVGProps<SVGSVGElement>;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        opacity="0.4"
        d="M10.5423 2.4375C11.9207 2.43749 13.0124 2.43748 13.8668 2.55236C14.746 2.67057 15.4578 2.91966 16.0191 3.48093C16.5803 4.04221 16.8294 4.75392 16.9477 5.63324C17.0625 6.48764 17.0625 7.66395 17.0625 9.0423C17.0625 10.4206 17.0625 11.5124 16.9477 12.3668C16.8294 13.246 16.5803 13.9578 16.0191 14.5191C15.4578 15.0803 14.746 15.3294 13.8668 15.4477C13.0124 15.5625 11.9207 15.5625 10.5424 15.5625H7.45769C6.07939 15.5625 4.98764 15.5625 4.13324 15.4477C3.25392 15.3294 2.54221 15.0803 1.98093 14.5191C1.41966 13.9578 1.17057 13.246 1.05236 12.3668C0.937478 11.5124 0.937485 10.4207 0.9375 9.0423C0.937485 7.66403 0.937478 6.48764 1.05236 5.63324C1.17057 4.75392 1.41966 4.04221 1.98093 3.48093C2.54221 2.91966 3.25392 2.67057 4.13324 2.55236C4.98764 2.43748 6.07937 2.43749 7.45768 2.4375H10.5423Z"
        fill="#1453F5"
      />
      <path
        d="M5.47437 8.55233C3.94291 8.95125 2.8125 10.3436 2.8125 12C2.8125 12.3106 3.06434 12.5625 3.375 12.5625H9.375C9.68565 12.5625 9.9375 12.3106 9.9375 12C9.9375 10.3436 8.8071 8.95125 7.27563 8.55233C7.74848 8.2533 8.0625 7.72583 8.0625 7.125C8.0625 6.19302 7.30698 5.4375 6.375 5.4375C5.44302 5.4375 4.6875 6.19302 4.6875 7.125C4.6875 7.72583 5.00151 8.2533 5.47437 8.55233Z"
        fill="#1453F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6875 6.75C10.6875 6.33579 11.0233 6 11.4375 6H14.4375C14.8517 6 15.1875 6.33579 15.1875 6.75C15.1875 7.16421 14.8517 7.5 14.4375 7.5H11.4375C11.0233 7.5 10.6875 7.16421 10.6875 6.75Z"
        fill="#1453F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6875 9.375C10.6875 8.96078 11.0233 8.625 11.4375 8.625H14.4375C14.8517 8.625 15.1875 8.96078 15.1875 9.375C15.1875 9.78922 14.8517 10.125 14.4375 10.125H11.4375C11.0233 10.125 10.6875 9.78922 10.6875 9.375Z"
        fill="#1453F5"
      />
    </svg>
  );
};
